function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M2.5 8.68018C2.5 6.01518 2.5 4.68268 2.815 4.23435C3.12917 3.78685 4.38167 3.35768 6.8875 2.50018L7.365 2.33685C8.67083 1.88935 9.32333 1.66602 10 1.66602C10.6767 1.66602 11.3292 1.88935 12.635 2.33685L13.1125 2.50018C15.6183 3.35768 16.8708 3.78685 17.185 4.23435C17.5 4.68268 17.5 6.01602 17.5 8.68018V9.99185C17.5 14.6902 13.9675 16.971 11.7508 17.9385C11.15 18.201 10.85 18.3327 10 18.3327C9.15 18.3327 8.85 18.201 8.24917 17.9385C6.0325 16.9702 2.5 14.691 2.5 9.99185V8.68018Z",
  stroke: "#202125",
  strokeWidth: 1.5
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M9.9987 9.16536C10.9192 9.16536 11.6654 8.41917 11.6654 7.4987C11.6654 6.57822 10.9192 5.83203 9.9987 5.83203C9.07822 5.83203 8.33203 6.57822 8.33203 7.4987C8.33203 8.41917 9.07822 9.16536 9.9987 9.16536Z",
  stroke: "#202125",
  strokeWidth: 1.5
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M13.3346 12.4987C13.3346 13.4195 13.3346 14.1654 10.0013 14.1654C6.66797 14.1654 6.66797 13.4195 6.66797 12.4987C6.66797 11.5779 8.15964 10.832 10.0013 10.832C11.843 10.832 13.3346 11.5779 13.3346 12.4987Z",
  stroke: "#202125",
  strokeWidth: 1.5
});
const SvgBadge = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/badge.709272c7.svg";
export { ForwardRef as ReactComponent };